// import toast from 'react-hot-toast';
import { Translate, useTranslate } from '~/i18n';
import Container from '../common/container';
import TabbyWidget from '../common/tabby-widget';
import TamaraWidgetV2 from '../common/tamara-widget-v2';
import { DetailsCollapsableSection } from './collapsable-section';
import { ExperienceImageGallery } from './image-gallery';
import Itinerary from './itinerary';
import { BookingDetailsCTA } from './cta';
import { ExperienceDetailsProps } from '~/interfaces/experience';
import { CheckIcon, CloseIcon } from '~/svgs/common';
import { DetailsShare } from './share';
import { experienceShareDataLayer } from '~/analytics/gtm/events';
// import { UserType } from '~/interfaces/user';
// import { useAuth } from '~/auth';
// import Axios from '~/utils/axios';
// import { sentryCaptureException } from '~/errors/sentry';
// import Loading from '../common/loaders/loader';
// import { generateSSIDLoginURL, storeAndSSIDLogin } from '~/utils/ssid-login';
// import destinations from '~/data/destinations';

type Props = {
   data: ExperienceDetailsProps;
   reviews: {
      curr_page: number;
      experience_rating: number;
      last_page: number;
      organizer_rating: number;
      overall_rating: number;
      reviews: any[];
      total: number;
      venue_rating: number;
      price_rating: number;
   };
   suggestedExp: any[];
};
export const ExperienceDetailsContent = ({ data, reviews }: Props) => {
   // const { authenticated, user, updateUser } = useAuth<UserType>();
   const { locale, translate } = useTranslate();
   // const router = useRouter();
   // const [loading, setLoading] = useState(false);
   const lat = +data.latlng?.split(',')[0];
   const lng = +data.latlng?.split(',')[1];
   const isFree = !data.price_start_from && !data.discounted_price && !data.list_price;
   // const existingDestination = destinations?.find((city: string) => {
   //    return String(data?.city_slug_filter)?.toLowerCase()?.includes(city);
   // });

   // const exploreBtn = (
   //    <button className="flex items-center justify-between px-4 py-2 rounded-lg bg-madinah-primary">
   //       <span className="font-semibold">
   //          <Translate id="common:explore" />
   //       </span>
   //       {lang === 'sa-ar' ? (
   //          <AngelLeftIcon className="transform scale-75" />
   //       ) : (
   //          <AngelRightIcon className="transform scale-75" />
   //       )}
   //    </button>
   // );

   const LocalizedList = ({ icon, list }: { list: any[]; icon?: React.ReactNode }) => {
      return (
         <ul>
            {list?.map((item, index) => (
               <li className="flex mt-2 text-lg first:mt-0" key={index}>
                  <div className="w-10">{icon}</div>
                  <span>{item[locale]}</span>
               </li>
            ))}
         </ul>
      );
   };

   // const updateWishlist = async (is_logged_in?: boolean) => {
   //    const _venue_id = data?.venue_id;
   //    if (!authenticated && !is_logged_in) {
   //       const authUrl = await generateSSIDLoginURL(locale);
   //       storeAndSSIDLogin({ router });
   //       router.replace(authUrl);
   //       return;
   //    }
   //    if (loading) return;
   //    setLoading(true);
   //    try {
   //       const { data } = await Axios.post('/user/wishlist', {
   //          venue_id: _venue_id,
   //       });

   //       if (is_logged_in) {
   //          window?.location?.reload();
   //       }

   //       const is_wishlist =
   //          data?.message === 'Successfully Removed from wishlist' ||
   //          user?.wishlist?.includes(_venue_id);

   //       if (data.status === 'Success') {
   //          setLoading(false);
   //          toast(
   //             <span>
   //                {is_wishlist
   //                   ? translate({ id: 'auth:removed from your wishlist' })
   //                   : translate({ id: 'auth:added to your wishlist' })}
   //             </span>,
   //             {
   //                icon: is_wishlist ? (
   //                   <img
   //                      src="/icons/profile/heart-primary-border.png"
   //                      title={translate({ id: 'auth:add to wishlist' })}
   //                      className="w-6 mx-0.5 my-0.5"
   //                   />
   //                ) : (
   //                   <img
   //                      src="/icons/profile/heart-filled.png"
   //                      title={translate({ id: 'auth:remove from wishlist' })}
   //                      className="w-6 mx-0.5 my-0.5"
   //                   />
   //                ),
   //                style: {
   //                   background: '#fef6d6',
   //                },
   //             }
   //          );
   //          if (is_wishlist) {
   //             const _wishlist = user?.wishlist?.filter(item => item !== _venue_id);
   //             updateUser({ ...user, wishlist: _wishlist });
   //          } else {
   //             const _wishlist = [...user.wishlist, ...[_venue_id]];
   //             updateUser({ ...user, wishlist: _wishlist });
   //          }
   //          if (is_logged_in) {
   //             window?.location?.reload();
   //          }
   //       } else {
   //          throw new Error(translate({ id: 'business:failed toaster' }));
   //       }
   //    } catch (error) {
   //       setLoading(false);
   //       sentryCaptureException(error, { tags: { journey: 'business' } });
   //    }
   // };

   // const favIcon = useMemo(() => {
   //    const is_wishlist = user?.wishlist?.includes(data?.venue_id);
   //    return is_wishlist ? (
   //       <img
   //          src="/icons/profile/heart-filled.png"
   //          title={translate({ id: 'auth:remove from wishlist' })}
   //          className="mx-[3px] my-[2px] pt-0.5 w-5 h-5"
   //       />
   //    ) : (
   //       <img
   //          src="/icons/profile/heart-primary-border.png"
   //          title={translate({ id: 'auth:add to wishlist' })}
   //          className="mx-[3px] my-[2px] pt-0.5 w-5 h-5"
   //       />
   //    );
   // }, [translate, user, data?.venue_id]);

   const getDurationInHours = (totalMinutes: number) => {
      const hours = Math.trunc(totalMinutes / 60);
      const minutes = totalMinutes % 60;
      return `${hours}:${minutes < 10 ? '0' + minutes : minutes}`;
   };

   return (
      <div className="pt-2 md:container md:mx-auto">
         {/* {loading ? (
            <div className="fixed inset-0 bg-black bg-opacity-50 z-70">
               <div className="relative top-1/2">
                  <Loading color="white" size={68} />
               </div>
            </div>
         ) : null} */}
         <Container>
            {/* <Breadcrumb
               className="py-4 text-sm grow tablet:pt-6"
               items={[
                  {
                     href: `/${data?.city_slug_filter}`,
                     name: data?.city,
                  },
                  // {
                  //    href: `/${data.region?.slug}/experiences`,
                  //    name: translate({ id: 'common:experiences' }),
                  // },
                  {
                     name: data.category?.[`title_${locale}`],
                     href: `/${data?.city_slug_filter}/experiences/c/${data.category?.[`slug_${locale}`]}`,
                  },
                  {
                     name: data.name,
                     href: router.asPath,
                     disabled: true,
                  },
               ]}
            /> */}
            <div className="pt-4 font-normal leading-none uppercase text-madinah-primary">
               <Translate id="common:experience" />
            </div>
         </Container>
         <div className="flex flex-col mt-2">
            <Container>
               <div>
                  <h1 className="font-primary mb-2 font-bold capitalize text-5xl md:text-[60px]">
                     {data.name}
                  </h1>
                  {/* <div className="flex items-center gap-2 mb-8 lg:mb-4">
                     <div className="relative w-8 h-8 border rounded-full">
                        <ImageProxy
                           width={31}
                           height={31}
                           className="object-cover rounded-full"
                           src={data.organizer_logo}
                        />
                     </div>

                     <div className="text-sm font-semibold">
                        <span className="lowercase">
                           <Translate id="common:by" />
                        </span>
                        {data?.group_slug ? (
                           <NextLink
                              href={`/organizer/${data.group_slug}`}
                              className="text-madinah-primary">
                              {data.organizer_name}
                           </NextLink>
                        ) : (
                           data.organizer_name
                        )}
                     </div>
                  </div> */}
               </div>
            </Container>
            <ExperienceImageGallery
               images={data.optimized_images}
               video={data.venue_video_url}
               analytics={{
                  event_location: data.city,
                  package_name: data.name,
                  package_price: String(data.discounted_price || data.list_price),
               }}
            />
         </div>
         <div className="flex flex-col mb-2 space-y-4 lg:space-y-0 lg:flex-row">
            <div className="w-full lg:w-[69%] lg:ltr:pr-4 lg:rtl:pl-4">
               {!isFree && data.is_tabby ? (
                  <div className="m-3 sm:hidden">
                     <TabbyWidget
                        elementId="tabby-info-mobile"
                        price={data.price_start_from || data.discounted_price || data.list_price}
                     />
                  </div>
               ) : null}

               {!isFree && data.is_tamara ? (
                  <div className="m-3 sm:hidden">
                     <TamaraWidgetV2
                        price={data.price_start_from || data.discounted_price || data.list_price}
                     />
                  </div>
               ) : null}

               <Container>
                  <div className="flex items-center justify-between mb-8">
                     <h3 className="font-bold text-[30px] lg:text-4xl text-black">
                        <Translate id="common:overview" />
                     </h3>
                     <div className="flex items-center gap-4">
                        {/* <div
                           className="h-10 w-10 !rounded-[13px] bg-white border-none flex justify-center items-center hover:cursor-pointer"
                           onClick={e => {
                              e.preventDefault();
                              updateWishlist();
                           }}>
                           {favIcon}
                        </div> */}
                        <DetailsShare
                           small
                           onShareClick={() =>
                              experienceShareDataLayer({
                                 event_location: data.city,
                                 package_name: data.name,
                                 package_price: String(data.discounted_price || data.list_price),
                              })
                           }
                           share_title={
                              data[`meta_title_${locale}`] || translate({ id: 'seo:home title' })
                           }
                           share_description={
                              data[`meta_description_${locale}`] ||
                              translate({ id: 'seo:home description' })
                           }
                           classNames="h-10 !rounded-[13px] bg-white border-none"
                        />
                     </div>
                  </div>

                  <div
                     className="mb-5"
                     dangerouslySetInnerHTML={{ __html: data.rt_description || data.description }}
                  />
                  <h3 className="font-bold text-[30px] lg:text-4xl mt-10 mb-8">
                     <Translate id="common:information" />
                  </h3>
                  {data.itinerary?.length ? (
                     <Itinerary
                        itinerary={data.itinerary}
                        analytics={{
                           event_location: data.city,
                           package_name: data.name,
                           package_price: String(data.discounted_price || data.list_price),
                        }}
                     />
                  ) : null}
                  {data.included?.length ? (
                     <DetailsCollapsableSection
                        title={<Translate id="booking:what is included" />}
                        wrapperClassName="border-t-0">
                        <LocalizedList list={data.included} icon={<CheckIcon />} />
                     </DetailsCollapsableSection>
                  ) : null}
                  {data.excluded?.length ? (
                     <DetailsCollapsableSection
                        title={<Translate id="booking:what is not included" />}>
                        <LocalizedList
                           list={data.excluded}
                           icon={<CloseIcon className="text-primary-error" />}
                        />
                     </DetailsCollapsableSection>
                  ) : null}

                  {data.guest_requirements?.length ? (
                     <DetailsCollapsableSection title={<Translate id="booking:what to bring" />}>
                        <LocalizedList list={data.guest_requirements} icon={<CheckIcon />} />
                     </DetailsCollapsableSection>
                  ) : null}
                  {data.refund_policy_details?.[locale] ? (
                     <DetailsCollapsableSection title={<Translate id="booking:refund policy" />}>
                        <div
                           className="prose"
                           dangerouslySetInnerHTML={{ __html: data.refund_policy_details[locale] }}
                        />
                     </DetailsCollapsableSection>
                  ) : null}

                  {/* {data?.city_image_path ? (
                     <div className="relative min-h-[360px] h-[460px] max-h-[460px] rounded-lg overflow-hidden mt-10">
                        <Image
                           layout="fill"
                           objectFit="fill"
                           className="!object-cover"
                           src={data?.city_image_path}
                           priority
                        />
                        <div className="absolute inset-x-0 bottom-0 p-14 flex items-end h-1/2 bg-gradient-to-t from-black/50 to-transparent backdrop-blur-[1.5px]">
                           <div className="text-white">
                              <h1
                                 className="mx-auto text-5xl font-bold"
                                 style={{ textShadow: '0px 0px 16px rgba(0, 0, 0, 0.50)' }}>
                                 <Translate
                                    id="common:discover city"
                                    values={{ city_name: data?.city }}
                                 />
                              </h1>
                              <p className="relative py-3 text-lg font-semibold">
                                 {data?.city_description || ''}
                              </p>
                              {existingDestination ? (
                                 <a
                                    href={`https://www.visitsaudi.com/${locale}/${existingDestination}`}
                                    target="_blank"
                                    rel="noreferrer noopener">
                                    {exploreBtn}
                                 </a>
                              ) : (
                                 <NextLink href={`/${data?.city_slug_filter}`}>
                                    {exploreBtn}
                                 </NextLink>
                              )}
                           </div>
                        </div>
                     </div>
                  ) : null} */}
               </Container>
            </div>

            <BookingDetailsCTA
               price={data.list_price}
               discounted_price={data.discounted_price}
               id={data._id}
               city={data.city}
               venue_type={data.venue_type}
               book_online={data.book_online === 'Yes'}
               external_link={data.venue_external_link}
               is_dmc={data.is_dmc}
               is_external={data.is_external}
               gender={data.gender}
               venue_type_details={data.venue_type_details}
               share_title={data.name}
               price_start_from={data.price_start_from}
               booking_closed={data?.booking_closed}
               is_tabby={data.is_tabby}
               is_tamara={data.is_tamara}
               min_participants={data?.facilities?.[0]?.min_participants || 1}
               duration={
                  data.duration_unit === 'minutes' && data.duration > 60
                     ? `${getDurationInHours(data.duration)} ${translate({ id: 'common:hours' })}`
                     : `${data.duration} ${data.duration_unit === 'days' ? translate({ id: 'common:days' }) : data.duration_unit}`
               }
               age_from={data.age_from}
               age_to={data.age_to}
               lat={lat}
               lng={lng}
               reviews={reviews}
               category={data?.category || {}}
               tags={data?.tags || []}
            />
         </div>
      </div>
   );
};
